import React from 'react';
import BaseParametroCrud from './BaseParametroCrud';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';

export default function TipoVulneracionDdhh() {
    const { token } = useAuth();
    const [modulosDdhh, setModulosDdhh] = React.useState([]);

    React.useEffect(() => {
        fetchModulosDdhh();
    }, []);

    const fetchModulosDdhh = async () => {
        try {
            const response = await apiService.get('/parametros/modulosddhh', token);
            const result = await response.data;
            setModulosDdhh(result);
        } catch (error) {
            console.error('Error fetching módulos DDHH:', error);
        }
    };

    return (
        <BaseParametroCrud
            header={{
                title: 'Tipo vulneración DDHH',
                idCabezaFamilia: '1',
                url: '/parametros',
                nombreurl: 'Parámetros',
                nombreform: 'Tipo vulneración DDHH'
            }}
            formTitle="Formulario tipo vulneración DDHH"
            loadUrl="/parametros/tipovulneracionddhh"
            saveUrl="/parametros/guardartipovulneracionddhh"
            alertTitle="Guardar tipo vulneración DDHH"
            defaultValues={{
                id: 0,
                strNombre: '',
                bolActivo: false,
                intModuloddhhid: 0
            }}
            mapRowToForm={(row) => ({
                id: row.id,
                strNombre: row.strNombre,
                bolActivo: row.bolActivo,
                intModuloddhhid: row.intModuloddhhid
            })}
            columns={[
                { key: 'id', title: 'Id' },
                { key: 'strNombre', title: 'Nombre' },
                {
                    key: 'bolActivo',
                    title: 'Estado',
                    render: (row) => (row.bolActivo ? 'Activo' : 'Inactivo')
                },
                { key: 'intModuloddhhid', title: 'Módulo DDHH' }
            ]}
            renderFormFields={({ register, errors }) => (
                <>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="strNombre">Nombre</label>
                                <input
                                    {...register('strNombre', { required: true })}
                                    className="form-control"
                                    placeholder="Nombre"
                                    id="strNombre"
                                />
                                {errors.strNombre && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        {...register('bolActivo')}
                                        className="custom-control-input"
                                        id="SwitchEstado"
                                    />
                                    <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="intModuloddhhid">Módulo DDHH</label>
                                <select
                                    {...register('intModuloddhhid', { required: true })}
                                    className="form-control"
                                    id="intModuloddhhid"
                                >
                                    <option value="">Seleccionar módulo</option>
                                    {modulosDdhh.map((modulo) => (
                                        <option key={modulo.id} value={modulo.id}>
                                            {modulo.str_nombre}
                                        </option>
                                    ))}
                                </select>
                                {errors.intModuloddhhid && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                    </div>
                </>
            )}
        />
    );
}